import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomerCreateModel, CustomerServiceProxy, CustomerStatusModel, CustomerStatusServiceProxy } from '../../../../shared/service-proxies/event-service-proxy';
import { ModalService } from '../../../services/modal/modal.service';
import { AuthService } from '../../../services/auth/auth.service';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { takeUntil } from 'rxjs';
import { ToastrService } from '../../../services/toastr/toastr.service';
import { ErrorService } from '../../../services/error/error.service';

@Component({
    selector: 'app-modal-create-customer',
    templateUrl: './modal-create-customer.component.html',
    styleUrl: './modal-create-customer.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class ModalCreateCustomerComponent implements OnInit {
  public customerForm: CustomerCreateModel = new CustomerCreateModel();
  public statuses: CustomerStatusModel[] = [];
  isLoadingSend: boolean = false;

  @Output() changeState = new EventEmitter<boolean>(false)
  
  constructor(private toastrService: ToastrService, private errorService: ErrorService, private _customerServiceProxy: CustomerServiceProxy, private modalService: ModalService, private authService: AuthService, private _statusServiceProxy: CustomerStatusServiceProxy, private destroyService: DestroyService) {
  }

  removeReadonly(event: Event): void {
  (event.target as HTMLInputElement).removeAttribute('readonly');
}


  ngOnInit(): void {
    this.getAllStatuses();
  }

  closeModal() {
    this.modalService.closeModal();
    this.clearFormData();
  }

  createCustomer() {
    this.isLoadingSend = true;
    this.customerForm.companyId = this.authService.getCompanyId();

    if (!this.customerForm.status) {
      this.customerForm.status = new CustomerStatusModel();
    }
    this.customerForm.status.id = this.statuses.find(status => status.name === 'Новый')?.id || null;
    this._customerServiceProxy.create(this.customerForm)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(() => {
      this.changeState.emit(true);
        this.closeModal();
        this.isLoadingSend = false;
        this.toastrService.showSuccessToastr('Клиент успешно создан!');
      }, error => {
        this.isLoadingSend = false;
        this.errorService.handleError(error, 'Не удалось создать клиента. Попробуйте позже.');
    });
  }

  getAllStatuses() {
    this._statusServiceProxy.getAll(this.authService.getCompanyId())
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(res => {
        this.statuses = res;
        console.log(this.statuses);
    })
  }
  clearFormData() {
    this.customerForm = new CustomerCreateModel();
  }
}
